var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"disabled":!_vm.showTip,"effect":"dark","content":_vm.content.toString(),"placement":"top-start"}},[_c('div',{staticClass:"parent-box"},[_c('p',{staticClass:"text-overlow-box",class:_vm.uuid},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }